import React, { useState } from "react"
import { TabNav } from "./TabNav"
import { TabPane } from "./TabPanel"

type Props = {
    items: { [key: string]: JSX.Element | undefined }
}

export function Tabs({ items }: Props) {
    const [tab, setTab] = useState<string>(Object.keys(items)[0])

    return <div>
        <ul
            className="nav nav-tabs scrollbar-custom mb-12 flex items-center justify-start overflow-x-auto overflow-y-hidden border-b border-jacarta-500 pb-px dark:border-jacarta-500 md:justify-center"
            role="tablist">
            {
                Object.keys(items).map(label => <TabNav onClick={label => setTab(label)} active={label === tab} label={label} key={label} />)
            }
        </ul>

        <div className="tab-content">
            {
                Object.keys(items).map(label => <TabPane key={label} active={label === tab} > {items[label]} </TabPane>)
            }
        </div>
    </div>
}